import { createSlice } from "@reduxjs/toolkit";
import { ICV_STATUS } from "../../utils/Constant";


const initialState: any = {
  isLoading: false,
  storeICVGetStatesData: {},
  storeICVGetSeasonsData: {},
  storeICVGetYearData: {},
  storeICVGetDistrictData:{},
  storeICVGetMandalData:{},
  storeICVGetPMFBYVillagesData:{},
  storeICVGetVillagesData:{},
  storeICVGetCropsMastersData:{},
  storeICVGetCCEUsersData:{},
  storeICVGetAssignSurveyorData:{},
  storeICVGetInfoData: {
    data: [],
    count: 0,
  },
  storeICVData: {
    data: [],
    count: 0,
  },
  storeICVGetLevel5Data:{},
  storeICVGetLevel6Data:{},
  storeICVGetDownLoadCSVData:{},
  storeICVGetFailedReportData:{},
  storeICVAzureFileServiceData:{},
  storeICVGetPolicyReportData:{},
  storeICVGetSurveyStatusData: {},
  storeICVGetQCUsersData: { data: [] },
  storeICVStatusUpdateRes: {},
  selectedICVActivities: [],
  storeICVAssignQC: {},
  storeICVReassignQC: {}
};

export const icvActivitySlice = createSlice({
  name: "icvActivity",
  initialState,
  reducers: {
    startLoadingICV(state) {
      state.isLoading = true;
    },
    stopLoadingICV(state) {
      state.isLoading = false;
    },
    handleSelectICVActivitySlice(state, action) {
      const { itemId, checked, statusId, record } = action.payload;
      if (checked) {
        // Check if record already exists by icvId
        const existingIndex = state.selectedICVActivities.findIndex((item: any) => item.icvId === itemId);
        if (existingIndex === -1) {
          state.selectedICVActivities.push(record);
        }
      } else {
        state.selectedICVActivities = state.selectedICVActivities.filter((item: any) => item.icvId !== itemId);
      }
    },
    handleBulkSelectICVActivitySlice(state, action) {
      const { itemIds, checked, records } = action.payload;
      if (checked) {
        itemIds.forEach((itemId: string) => {
          const record = records.find((r: any) => r.icvId === itemId);
          if (record) {
            const existingIndex = state.selectedICVActivities.findIndex((item: any) => item.icvId === itemId);
            if (existingIndex === -1) {
              state.selectedICVActivities.push(record);
            }
          }
        });
      } else {
        state.selectedICVActivities = state.selectedICVActivities.filter((item: any) => !itemIds.includes(item.icvId));
      }
    },
    clearSelectedICVActivities(state){
      state.selectedICVActivities = [];
    },
    handleClearICVActivitySelectionSlice(state) {
      state.selectedICVActivities = [];
    },
    handleICVGetSurveyStatusDataSlice(state, action) {
      state.storeICVGetSurveyStatusData = action.payload;
    },
    handleICVGetQCUsersDataSlice(state, action) {
      state.storeICVGetQCUsersData = action.payload;
    },
    handleICVGetStatesDataSlice(state, action) {
      state.storeICVGetStatesData = action.payload;
      // state.isLoading = false;
    },
    handleICVGetSeasonsDataSlice(state, action) {
      state.storeICVGetSeasonsData = action.payload;
      // state.isLoading = false;
    },
    handleICVGetYearDataSlice(state, action) {
      state.storeICVGetYearData = action.payload;
      // state.isLoading = false;
    },
    handleICVGetDistrictDataSlice(state, action) {
      state.storeICVGetDistrictData = action.payload;
      state.isLoading = false;
    },
    handleICVGetMandalDataSlice(state, action) {
      state.storeICVGetMandalData = action.payload;
      state.isLoading = false;
    },
    handleICVGetPMFBYVillagesDataSlice(state, action) {
      state.storeICVGetPMFBYVillagesData = action.payload;
      state.isLoading = false;
    },
    handleICVGetVillagesDataSlice(state, action) {
      state.storeICVGetVillagesData = action.payload;
      state.isLoading = false;
    },
    handleICVGetLevel5DataSlice(state,action){
      state.storeICVGetLevel5Data = action.payload;
      state.isLoading =false;
    },
    handleICVGetLevel6DataSlice(state,action){
      state.storeICVGetLevel6Data = action.payload;
      state.isLoading = false;
    },
    handleICVGetCropsMastersDataSlice(state,action){
      state.storeICVGetCropsMastersData = action.payload;
      // state.isLoading = false;
    },
    handleICVGetCCEUsersDataSlice(state,action){
     state.storeICVGetCCEUsersData = action.payload;
     state.isLoading =false;
    },
    handleICVGetDownLoadCSVDataSlice(state,action){
    state.storeICVGetDownLoadCSVData = action.payload;
    state.isLoading = false;
    },
    handleICVGetAssignSurveyorDataSlice(state,action){
      state.storeICVGetAssignSurveyorData = action.payload;
      state.isloading = false;
    },
    handleICVGetFailedReportDataSlice(state,action){
      state.storeICVGetFailedReportData = action.payload;
      state.isloading = false;
    },
    handleICVGetInfoDataSlice(state, action) {
      state.storeICVGetInfoData = {
        data: action.payload.data,
        count: action.payload.count,
      };
      state.isLoading = false;
    },
    handleGetIcvDataSlice(state, action) {
      state.storeICVData = {
        data: action.payload.data,
        count: action.payload.count,
      };
      state.isLoading = false;
    },
    handleICVStatusUpdateSlice(state, action) {
      state.storeICVStatusUpdateRes = action.payload;
      state.isLoading = false;
    },
    handleICVAzureFileService(state,action){
      state.storeICVAzureFileServiceData =action.payload;
      state.isloading = false;
    },
    handleICVGetPolicyReportDataSlice(state,action){
      state.storeICVGetPolicyReportData = action.payload;
      state.isloading = false;
    },
    handleReassignQCSlice(state,action){
      state.storeICVReassignQC = action.payload;
      state.isloading = false;
    },
    handleAssignQCSlice(state,action){
      state.storeICVAssignQC = action.payload;
      state.isloading = false;
    },
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  startLoadingICV,
  handleICVGetSurveyStatusDataSlice,
  handleICVGetQCUsersDataSlice,
  handleICVGetStatesDataSlice,
  handleICVGetSeasonsDataSlice,
  handleICVGetYearDataSlice,
  handleICVGetDistrictDataSlice,
  handleICVGetMandalDataSlice,
  handleICVGetLevel5DataSlice,
  handleICVGetLevel6DataSlice,
  handleICVGetPMFBYVillagesDataSlice,
  handleICVGetVillagesDataSlice,
  handleICVGetCropsMastersDataSlice,
  handleICVGetCCEUsersDataSlice,
  handleICVGetAssignSurveyorDataSlice,
  handleICVGetDownLoadCSVDataSlice,
  handleICVGetInfoDataSlice,
  handleICVGetFailedReportDataSlice,
  handleICVAzureFileService,
  handleICVGetPolicyReportDataSlice,
  stopLoadingICV,
  handleGetIcvDataSlice,
  handleICVStatusUpdateSlice,
  handleSelectICVActivitySlice,
  handleBulkSelectICVActivitySlice,
  handleClearICVActivitySelectionSlice,
  handleReassignQCSlice,
  handleAssignQCSlice,
  clearSelectedICVActivities,
  hasError,
} = icvActivitySlice.actions;
export default icvActivitySlice.reducer;
